'use client';

import { CaretDown, CaretUp } from '@velocity-exchange/icons';
import { cm } from 'src/utils/classNames';
import { getColorVar } from 'src/utils/theme/colorVars';
import { WithClassName } from 'src/utils/UtilityTypes';

export type SortDirection = 'ascending' | 'descending' | 'neutral';

interface SortCaretProps extends WithClassName {
	onClick?: () => void;
	state: SortDirection;
}

export default function SortCaret({
	onClick,
	state,
	className,
}: SortCaretProps) {
	const getCaretColor = (isActive: boolean) => {
		if (isActive) {
			return getColorVar('text-disabled');
		}
		return getColorVar('tooltip-bg');
	};

	return (
		<div
			className={cm(
				'relative flex h-lg w-lg cursor-pointer flex-col items-center justify-center',
				className
			)}
			onClick={onClick}
		>
			<CaretUp
				className="absolute top-[-3px]"
				size={16}
				color={getCaretColor(state === 'ascending')}
			/>
			<CaretDown
				className="absolute bottom-[-3px]"
				size={16}
				color={getCaretColor(state === 'descending')}
			/>
		</div>
	);
}
